import {_} from 'vue-underscore'

export const makeStep = (stepQuestions, title, props) => {
  // remove the falsy values from the questions array
  const questions = stepQuestions.filter(
    question => !!question && !question.hidden
  )
  // return the step with questions
  return {
    title,
    hide: !questions.length,
    questions,
    ...props
  }
}

export const FlowGeneratorMixin = {
  methods: {
    async openStep(stepName, scrollTo = true) {
      await this.$nextTick()
      this.$refs.flowGenerator.flowPreview().activateStep(stepName, scrollTo)
    },
  }
}

export const getSelectedFoldType = (curtainTemplate, curtainParameters) => {
  // get selected mounting system for fold curtain
  if (!curtainTemplate.available_fold_types) {
    // no mounting systems -> not a fold curtain, return
    return null
  }
  return _.find(
    curtainTemplate.available_fold_types,
    el => el.fold_type === curtainParameters.fold_type
  )
}

export const getSelectedMountingSystem = (curtainTemplate, curtainParameters) => {
  // get selected mounting system for fold curtain
  if (!curtainTemplate.available_mounting_systems) {
    // no mounting systems -> not a fold curtain, return
    return null
  }
  return _.find(
    curtainTemplate.available_mounting_systems,
    el => el.mounting_system_type === curtainParameters.mounting_system
  )
}

export const getSelectedWaveDefinition = (curtainTemplate, curtainParameters) => {
  // get selected wave definition for wave curtain
  if (!curtainTemplate.wave_definition) {
    // no wave definition -> not a wave curtain, return
    return null
  }
  return _.find(
    curtainTemplate.wave_definition,
    el => el.runner_distance === curtainParameters.runner_distance
  )
}
